module.exports = __webpack_public_path__ + "img/menu-bim.4951451c.svg";